import { Button, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { BootstrapDialog } from 'styles/commonFunction'
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import axiosInstance from 'custom-axios';
import { useFullPageLoader } from 'hooks/useFullPageLoader';


function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    title='Close'
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const DiscardModal = (props) => {

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [discardReasonData, setDiscardReasonData] = useState()

    const submitDiscard = async () => {

        if (!discardReasonData || discardReasonData.trim() === '') {
            toast.info("Please Input the Reason.");
            return;
        }

        try {
            showLoader()

            const response = await axiosInstance.post('/api/user-application-decline', {
                user_id: props.userId,
                declined_by: props.loginId,
                decline: props.openFrom,
                reason: discardReasonData
            });

            if (response.success) {
                toast.success(response.message)
            } else {
                toast.error('Something went wrong.')
            }

        } catch (error) {
            // console.error('Error submitting discard reason:', error);
        }
        props.fetchRolePermission()
        props.fetchUserInfo()
        props.handleClose();
        hideLoader()
    }

    return (
        <>
            <BootstrapDialog
                onClose={props.handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.open}
                fullWidth={true}
                maxWidth={'sm'}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={props.handleClose}>
                    <Typography className='input-title d-flex text-capitalize'>
                        Reason
                    </Typography>
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <textarea className="allocation-textarea all_padding10px"
                                name="reason"
                                id="reason"
                                rows="10"
                                cols="83"
                                value={discardReasonData}
                                onChange={(e) => setDiscardReasonData(e.target.value)}
                            >
                            </textarea>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant='contained'
                        className='raintree-btn-yellow'
                        onClick={submitDiscard}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </BootstrapDialog>
            {loader}
        </>
    )
}

export default DiscardModal